import { Box, Button } from "@mui/material";

interface QuestionnaireNavigationProps {
  onNext: () => void;
  isDisabled: boolean;
  isSubmitting: boolean;
  isLastQuestion: boolean;
  buttonText: {
    submitting: string;
    submit: string;
    next: string;
  };
}

export default function QuestionnaireNavigation({
  onNext,
  isDisabled,
  isSubmitting,
  isLastQuestion,
  buttonText,
}: QuestionnaireNavigationProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        position: "sticky",
        bottom: 0,
        backgroundColor: "white",
        paddingTop: 2,
        paddingBottom: 4,
        boxShadow:
          "0 4px 100px 0 rgba(40, 44, 80, 0.25), 0 15px 45px 0 rgba(46, 75, 132, 0.27), 0 1.878px 5.635px 0 rgba(46, 75, 132, 0.14)",
        marginTop: "auto",
        marginLeft: -2,
        marginRight: -2,
        marginBottom: -2,
        paddingLeft: 2,
        paddingRight: 2,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      }}
    >
      <Button
        variant="contained"
        onClick={onNext}
        disabled={isDisabled}
        fullWidth
      >
        {isSubmitting
          ? buttonText.submitting
          : isLastQuestion
            ? buttonText.submit
            : buttonText.next}
      </Button>
    </Box>
  );
}
